import * as GQL from "src/types/graphql";
import * as RD from "src/types/remoteData";
import { BreadcrumbType } from ".";
import * as Url from "../url";

export const getBreadcrumbsForUserProfile = (
  organization: RD.RemoteData<unknown, GQL.Organization>
): BreadcrumbType[] => {
  return [
    {
      label: "Profile",
      href: organization
        .map((org) => Url.OrgAdmin.UserProfile.home(org))
        .withDefault("#"),
    },
  ];
};

export const getBreadcrumbsForSecurity = (
  organization: RD.RemoteData<unknown, GQL.Organization>
): BreadcrumbType[] => {
  return [
    ...getBreadcrumbsForUserProfile(organization),
    {
      label: "Security",
      href: organization
        .map((org) => Url.OrgAdmin.UserProfile.security(org))
        .withDefault("#"),
    },
  ];
};

export const getBreadcrumbsForNotifications = (
  organization: RD.RemoteData<unknown, GQL.Organization>
): BreadcrumbType[] => {
  return [
    ...getBreadcrumbsForUserProfile(organization),
    {
      label: "Notifications",
      href: organization
        .map((org) => Url.OrgAdmin.UserProfile.notifications(org))
        .withDefault("#"),
    },
  ];
};
